export interface PasswordChecks {
  hasUppercase: boolean
  hasNumber:    boolean
  hasSymbol:    boolean
  hasMinLength: boolean
}

const WORDS = [
  'able', 'acid', 'aged', 'also', 'area', 'army', 'away', 'back', 'ball', 'band',
  'bank', 'base', 'bath', 'bear', 'bell', 'best', 'bird', 'blow', 'blue', 'bold',
  'bone', 'book', 'boom', 'born', 'bowl', 'burn', 'busy', 'call', 'came', 'camp',
  'card', 'care', 'case', 'cash', 'cast', 'cave', 'cell', 'chef', 'chip', 'city',
  'clay', 'clip', 'club', 'coal', 'coat', 'coil', 'cold', 'colt', 'come', 'cook',
  'cool', 'copy', 'corn', 'cost', 'crew', 'crop', 'cure', 'dart', 'data', 'date',
  'dawn', 'dead', 'deal', 'dear', 'deck', 'deep', 'deer', 'deny', 'desk', 'dial',
  'diet', 'dirt', 'disk', 'dock', 'dome', 'done', 'door', 'dose', 'down', 'draw',
  'drip', 'drop', 'drum', 'dual', 'duke', 'dull', 'dump', 'dusk', 'dust', 'duty',
  'each', 'earn', 'ease', 'east', 'edge', 'epic', 'even', 'ever', 'evil', 'exam',
  'face', 'fact', 'fail', 'fair', 'fall', 'farm', 'fast', 'fate', 'fear', 'feel',
  'feet', 'felt', 'file', 'fill', 'film', 'find', 'fine', 'fire', 'firm', 'fish',
  'fist', 'flag', 'flat', 'flow', 'foam', 'fold', 'folk', 'fond', 'font', 'food',
  'foot', 'ford', 'fore', 'fork', 'form', 'fort', 'foul', 'free', 'from', 'fuel',
  'full', 'fund', 'fuse', 'gain', 'gate', 'gave', 'gear', 'gene', 'girl', 'give',
  'glad', 'glow', 'glue', 'goal', 'goes', 'gold', 'golf', 'gone', 'good', 'grab',
  'gray', 'grew', 'grin', 'grip', 'grow', 'gulf', 'guru', 'hack', 'hail', 'half',
  'hall', 'halt', 'hand', 'hang', 'hard', 'harm', 'harp', 'hash', 'haul', 'head',
  'heat', 'heel', 'help', 'herb', 'here', 'hero', 'high', 'hill', 'hint', 'hold',
  'hole', 'home', 'hood', 'hook', 'hope', 'horn', 'host', 'hour', 'hull', 'hunt',
]

const DIGIT_SUBS: Record<string, string> = { a: '4', e: '3', i: '1', o: '0', s: '5' }

function pick(): string {
  return WORDS[Math.floor(Math.random() * WORDS.length)]
}

function digitSub(word: string): string {
  const chars = word.split('')
  for (let i = 0; i < chars.length; i++) {
    const sub = DIGIT_SUBS[chars[i]]
    if (sub) { chars[i] = sub; return chars.join('') }
  }
  return word + '1'
}

export function getPasswordChecks(password: string): PasswordChecks {
  return {
    hasUppercase: /[A-Z]/.test(password),
    hasNumber:    /[0-9]/.test(password),
    hasSymbol:    /[!@#$%^&*()\-_+=[\]{}|;':",.<>?/`~]/.test(password),
    hasMinLength: password.length >= 8,
  }
}

export function getPasswordScore(checks: PasswordChecks): 0 | 1 | 2 | 3 | 4 {
  return Object.values(checks).filter(Boolean).length as 0 | 1 | 2 | 3 | 4
}

export function getPasswordLabel(score: number): 'Weak' | 'Fair' | 'Good' | 'Strong' {
  if (score <= 1) return 'Weak'
  if (score === 2) return 'Fair'
  if (score === 3) return 'Good'
  return 'Strong'
}

export function generatePassword(): string {
  const w1 = pick()
  const w2 = digitSub(pick())
  const w3 = pick()
  return `${w1}-${w2}-${w3.charAt(0).toUpperCase()}${w3.slice(1)}`
}
